export default {
  form: {
    shipping_company_name: {
      label: 'Companie',
      placeholder: 'Introduceți numele companiei',
    },
    shipping_phone_number: {
      label: 'Număr de telefon',
      placeholder: 'Introduceți numărul de telefon',
    },
    shipping_salutation: {
      label: 'Titlu',
      options: {
        mr: 'Dl',
        mrs: 'Dna',
      },
    },
    shipping_first_name: {
      label: 'Prenume',
      placeholder: 'Introduceți prenumele',
    },
    shipping_last_name: {
      label: 'Nume de familie',
      placeholder: 'Introduceți numele de familie',
    },
  },
  buttons: {
    back: 'Înapoi',
    next: 'Următor',
  },
};
